export CLUSTERING_BASED_ON_ATTR_AND_REL_KEYS = 'ClusteringBasedOnAttrAndRelKeys'
export CLUSTERING_BASED_ON_ATTR_AND_REL_VALUES = 'ClusteringBasedOnAttrAndRelValues'
export CLASSIFICATION_BASED_ON_ATTR_AND_REL_KEYS ='ClassificationBasedOnAttrAndRelKeys'
export CLASSIFICATION_BASED_ON_ATTR_AND_REL_VALUES ='ClassificationBasedOnAttrAndRelValues'
export REGRESSION_BASED_ON_ATT_AND_REL_VALUES = 'RegressionBasedOnAttrAndRelValues'

export trainingTypes = [
  { name: 'Clustering on keys', type: CLUSTERING_BASED_ON_ATTR_AND_REL_KEYS },
  { name: 'Clustering on values', type: CLUSTERING_BASED_ON_ATTR_AND_REL_VALUES },
  { name: 'Classification on keys', type: CLASSIFICATION_BASED_ON_ATTR_AND_REL_KEYS },
  { name: 'Classification on values', type: CLASSIFICATION_BASED_ON_ATTR_AND_REL_VALUES },
  { name: 'Regression on values', type: REGRESSION_BASED_ON_ATT_AND_REL_VALUES }
]

export parseFeatures = (attributes = '', relationsIn = '', relationsOut = '') ->
  attributes = attributes.split(',').filter((val) -> val isnt '') if attributes isnt '*'
  relationsIn = relationsIn.split(',').filter((val) -> val isnt '') if relationsIn isnt '*'
  relationsOut = relationsOut.split(',').filter((val) -> val isnt '') if relationsOut isnt '*'

  JSON.stringify({
    attributes
    relationsIn
    relationsOut
  })

export parseTarget = (targetKey, targetType) ->
  JSON.stringify({
    type: targetType
    key: targetKey
  })

parseQueryBody = (query) ->
  if !query? or query is ''
    query = """
      selectIn '*'
      selectOut '*'
    """
  JSON.stringify(new Weaver.QueryBuilder(query).build())

export predict = ({ queryType, queryBody, trainingId, dryRun, name }) ->
  parsedQuery = parseQueryBody(queryBody)
  plugin = await Weaver.Plugin.load(name)
  plugin.predict('query-builder', parsedQuery, trainingId, dryRun)

export train = ({ queryBody, trainingId, trainingType, targetParams, featureParams, name }) ->
  parsedQuery = parseQueryBody(queryBody)
  plugin = await Weaver.Plugin.load(name)
  plugin.train('query-builder', parsedQuery, trainingId, trainingType, targetParams, featureParams)

export getStatus = ({ trainingId, name }) ->
  plugin = await Weaver.Plugin.load(name)
  plugin.getStatus(trainingId)

export getTrainingIds = (boolString, name) ->
  plugin = await Weaver.Plugin.load(name)
  plugin.getTrainingIds(boolString)

export getTrainingInfo = ({ trainingId, name }) ->
  plugin = await Weaver.Plugin.load(name)
  plugin.getTrainingInfo(trainingId)
